<script lang="ts" setup>
import type { Emitter } from 'mitt'

const emit = defineEmits<{
  (e: 'submit'): void
}>()

function onClick() {
  emit('submit')
}
</script>

<template>
  <div class="m-mention">
    <div class="m-mention__button" @click="onClick">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-mention {
  &__button {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
</style>
